// this file is generated by update_shopify_store_data.py at 2026-01-26 20:25:21.593332
var courses = [
    {
        "course_id": "AB55FF0F-28BB-F011-99A0-005056A78EAA",
        "course_version": 1,
        "name": "Introduction to Qualitative Metasynthesis",
        "course_type": 1,
        "author_information": "Julie Barroso, PhD, ANP, FNAP, FAAN",
        "description": "Have you ever wondered how to bring together insights from multiple qualitative studies to inform practice and policy? This course will guide you through the foundational concepts, rationale, and practical steps of qualitative metasynthesis, an advanced method for synthesizing qualitative research. You will learn to define qualitative metasynthesis, understand its importance in evidence-based practice, design a robust study, and differentiate appropriate studies for inclusion. Through a structured, supportive, and academically rigorous approach, you will gain the skills needed to conduct and appraise qualitative metasynthesis in health, social science, or nursing research.",
        "learning_objectives_html": "By the end of this module, learners will be able to:\r\n<ol>Define qualitative metasynthesis and explain its dual nature as both a product and a process.</ol>\r\n    <ol>Describe the rationale for conducting qualitative metasynthesis and its role in advancing evidence-based practice.\r\n    </ol>\r\n    <ol>Identify key components and considerations in designing a qualitative metasynthesis study, including topic selection, population parameters, and time frame.\r\n    </ol>\r\n    <ol>Differentiate qualitative research from other types of studies and understand inclusion/exclusion criteria for synthesis.\r\n    </ol>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CE359C4F-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Introduction to Qualitative Metasynthesis",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "81F5DF4F-F6D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing: Introduction to Qualitative Metasynthesis",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Leadership Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Personal Development",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 2.5 contact hours to participants who complete all sections and complete the post course survey.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];